import { RoleDto } from './RoleDto';

export class ApplicationDto {
  id: string;
  name: string;
  value: string;
  roles: Array<RoleDto>;
}
